import { useEffect } from 'react';
import { useRouteError } from 'react-router';
import { AlertTriangle, Compass, RefreshCcw } from 'lucide-react';
import {
  Button,
  Empty,
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
  LinkButton,
} from '@/shared/ui';
import { shellCopy } from './shell-copy';

// Deliberate: literals, not useSiteContent(). These render inside the gate
// today, so the hook would work — but error UI must not depend on the
// subsystem it may be reporting on, or a failure there takes the error screen
// down with it.
const system = shellCopy;

/**
 * Rendered by react-router when a route element throws. Used both as the
 * root-level fallback and as the children-level errorElement (where it
 * renders inside the Layout chrome).
 */
export function RouteErrorPage() {
  const routeError = useRouteError();

  useEffect(() => {
    console.error('Route error:', routeError);
  }, [routeError]);

  return (
    <Empty className="min-h-[400px]">
      <EmptyHeader>
        <EmptyMedia variant="icon">
          <AlertTriangle />
        </EmptyMedia>
        <EmptyTitle>{system.routeErrorTitle}</EmptyTitle>
        <EmptyDescription>{system.routeErrorBody}</EmptyDescription>
      </EmptyHeader>
      <EmptyContent>
        <Button variant="outline" onPress={() => window.location.reload()}>
          <RefreshCcw className="mr-1" />
          {system.reload}
        </Button>
      </EmptyContent>
    </Empty>
  );
}

/** Catch-all 404 page, rendered inside the Layout chrome. */
export function NotFoundPage() {
  return (
    <Empty className="min-h-[400px]" data-testid="not-found">
      <EmptyHeader>
        <EmptyMedia variant="icon">
          <Compass />
        </EmptyMedia>
        <EmptyTitle>{system.notFoundTitle}</EmptyTitle>
        <EmptyDescription>{system.notFoundBody}</EmptyDescription>
      </EmptyHeader>
      <EmptyContent>
        <LinkButton href="/">{system.backHome}</LinkButton>
      </EmptyContent>
    </Empty>
  );
}
